import { SignOutIcon, SquaresFourIcon } from "@phosphor-icons/react";
import { ROUTES_LEGACY_WEBAPP } from "@payfac/constants";
import { setLocalStorage } from "@shared/constants";
import type { TFunction } from "i18next";
import type { DrawerItemProps } from "./header.type";

export const getDrawerItems = (t: TFunction) => {
  const routes = [
    {
      key: "webapp",
      label: t("backoffice.headerWebappLink"),
      variant: "icon",
      icon: SquaresFourIcon,
      onClick: () => {
        setLocalStorage("userType", "seller");

        window.location.href = ROUTES_LEGACY_WEBAPP.DASHBOARD.fullPath;
      },
    },
    {
      key: "logout",
      label: t("backoffice.headerLogoutLink"),
      variant: "icon",
      icon: SignOutIcon,
      link: ROUTES_LEGACY_WEBAPP.LOGOUT.fullPath,
    },
  ];

  return routes as DrawerItemProps[];
};
